import { enableProdMode, importProvidersFrom, provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';

import { FsAcl } from '@firestitch/acl';
import { FsDrawerUrlService } from '@firestitch/drawer';
import { FsProgressModule } from '@firestitch/progress';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { Acl } from '@common/services';

import { DrawerUrlService } from '@libs/drawers/drawer';

import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { CoreModule } from './app/core/core.module';
import { ProjectsModule } from './app/projects';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    importProvidersFrom(AppRoutingModule, CoreModule, ProjectsModule, FsProgressModule),
    {
      provide: ErrorStateMatcher,
      useClass: ShowOnDirtyErrorStateMatcher,
    },
    {
      provide: FsDrawerUrlService,
      useClass: DrawerUrlService,
    },
    {
      provide: FsAcl,
      useClass: Acl,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
  ],
});
